import { render } from "./RecentCallsTable.vue?vue&type=template&id=607a5e98"
import script from "./RecentCallsTable.vue?vue&type=script&lang=js"
export * from "./RecentCallsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__